import { render, staticRenderFns } from "./BooleanAttributeEditor.vue?vue&type=template&id=dcacae74"
import script from "./BooleanAttributeEditor.vue?vue&type=script&lang=js"
export * from "./BooleanAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports